import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

const _hoisted_3 = {
  key: 0,
  class: "base_main_header"
};
const _hoisted_4 = {
  key: 1,
  class: "base_main_margin_top"
};
const _hoisted_5 = {
  class: "content"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, " 选择优惠券 ", -1);

const _hoisted_7 = {
  class: "base_details_content_second"
};
const _hoisted_8 = {
  class: "base_screen_header"
};
const _hoisted_9 = {
  class: "base_details_content_second"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, " 已选优惠券 ", -1);

import StatusBar from "@com/StatusBar.vue";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import CancelAfterSale from "@com/order/CancelAfterSale.vue";
import ConfirmAfterSale from "@com/order/ConfirmAfterSale.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { $msg, $box } from "@ui/msg";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import $ from "@util/base";
import configApi from "@api/config";
import api from "@api/afterSaleOrder";
import couponApi from "@/api/coupon";
export default {
  __name: 'AfterSaleOrder',
  props: {
    type: {
      type: String
    },
    routeName: {
      type: String
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    route.watchRouter(props.routeName, () => {
      getData();
    }); // 1052001 待审核、1052004 已完成、1052003 已取消、1052002 处理中

    const statusList = reactive([{
      label: "全部",
      value: "all",
      total: 0
    }, {
      label: "待审核",
      value: "1052001",
      total: 0
    }, {
      label: "处理中",
      value: "1",
      total: 0
    }, {
      label: "已完成",
      value: "1052004",
      total: 0
    }, {
      label: "已取消",
      value: "1052003",
      total: 0
    }]);
    const baseOptions = ref([]);
    const base = ref(route.query().base || "");
    const orderCode = ref(route.query().orderCode || "");
    const afterSaleCode = ref(route.query().afterSaleCode || "");
    const total = ref(0);
    const data = ref([]);
    getConfig();

    function getConfig() {
      configApi.base(val => {
        baseOptions.value = val;
      });
    }

    function getOperations(data) {
      if (props.type == "order") {
        // 1052001	待审核
        // 1052002	已审核
        // 1052003	已取消
        // 1052004	已完成
        // 1052005	待退回货物
        // 1052006	已退回待确认
        // 1052007	退款中
        // 1053	售后类型
        // 1053001	退货退款
        // 1053002	仅退款
        // 1054	通用任务类型
        // 1054001	退款单自动退款
        // 1054002	售后单退还储值金额
        let operations = [OPERATIONS.check];

        if (data.afterSaleStatus == "1052001") {
          operations.push(OPERATIONS.confirmAfterSale);
          operations.push(OPERATIONS.cancelAfterSale);
        } else if (data.afterSaleStatus == "1052005" || data.afterSaleStatus == "1052006") {
          operations.push(OPERATIONS.confirmTakeOver);
        }

        console.log("data.isSend" + JSON.stringify(data.isSend == 0));

        if (data.isSend == 0) {
          operations.push(OPERATIONS.giveCoupon);
        }

        return operations;
        /*switch (data.afterSaleStatus) {
          case "1052001":
            return [
              OPERATIONS.check,
              OPERATIONS.confirmAfterSale,
              OPERATIONS.cancelAfterSale,
            ];
          case "1052005":
            return [OPERATIONS.check, OPERATIONS.confirmTakeOver];
          case "1052006":
            return [OPERATIONS.check, OPERATIONS.confirmTakeOver];
          default:
            return [OPERATIONS.check];
        }*/
      } else {
        return [OPERATIONS.check];
      }
    }

    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "订单类型",
        prop: "mainBusiTypeName",
        width: 120
      }, {
        label: "售后单号",
        prop: "afterSaleCode"
      }, {
        label: "订单编号",
        prop: "orderCode"
      }, {
        label: "退款金额",
        prop: "refundMoney",
        width: 120
      }, {
        label: "退款余额",
        prop: "depositMoney",
        width: 120
      }, {
        label: "售后状态",
        prop: "afterSaleStatusName",
        width: 120
      }, {
        label: "售后类型",
        prop: "orderTypeName",
        width: 90
      }, {
        label: "售后时间",
        prop: "createTime",
        width: 100
      }]
    };
    const cancelAfterSaleRef = ref(null);
    const confirmAfterSaleRef = ref(null);
    let selectOpData = null;
    const opHander = operationsHander();
    opHander.install(OP_KEY.check, data => {
      switch (data.mainBusiType) {
        case "1017001":
          route.push({
            name: "goodsorderdetails",
            query: {
              code: data.orderCode,
              afterSaleCode: data.afterSaleCode,
              type: "after"
            }
          });
          break;

        case "1017002":
          route.push({
            name: "travelorderdetails",
            query: {
              code: data.orderCode,
              afterSaleCode: data.afterSaleCode,
              type: "after"
            }
          });
          break;

        case "1017003":
          route.push({
            name: "hotelorderdetails",
            query: {
              code: data.orderCode,
              afterSaleCode: data.afterSaleCode,
              type: "after"
            }
          });
          break;
      }
    });

    function confirmAfterSale(money, deposit) {
      api.confirm(selectOpData.afterSaleCode, money, deposit, () => {
        $msg.succ("退款成功");
        getData();
      });
    }

    const expenseAftersale = ref(null);
    const refundMoney = ref(null);
    const depositMoney = ref(null);
    opHander.install(OP_KEY.confirmAfterSale, data => {
      selectOpData = data;
      expenseAftersale.value = data.expenseAftersale;
      refundMoney.value = data.refundMoney;
      depositMoney.value = data.depositMoney;
      console.log("da222222ta" + JSON.stringify(data));
      confirmAfterSaleRef.value.show();
    });
    opHander.install(OP_KEY.cancelAfterSale, data => {
      selectOpData = data;
      cancelAfterSaleRef.value.show();
    });

    function cancelAfterSale(data) {
      if (selectOpData != null) {
        api.cancel({
          afterSaleCode: selectOpData.afterSaleCode,
          remark: data.reason
        }, () => {
          $msg.succ("取消成功");
          getData();
        });
      } else {
        $msg.error("请重新选择记录操作");
      }
    }

    opHander.install(OP_KEY.confirmTakeOver, data => {
      $box.alert("确认收货", `<div>确定已收到退货商品？</div><div>${data.expressName}：${data.expressNo}</div>`, () => {
        api.takeOver(data.afterSaleCode, () => {
          $msg.succ("确定收货成功");
          getData();
        });
      });
    });
    const giveCouponDrawer = ref(false);
    const couponName = ref("");
    const couponTableRef = ref(null);
    const couponData = ref([]);
    const couponDataConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getCouponDataOperations
      },
      column: [{
        label: "名称",
        prop: "name",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "当前状态",
        prop: "enableStatusName",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const couponDataSize = ref(10);
    const couponDataPage = ref(1);
    const couponDataTotal = ref(0);
    const couponDataHandler = operationsHander();
    const giveCouponData = ref([]);
    const giveCouponDataConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getGiveCouponOperations
      },
      column: [{
        label: "名称",
        prop: "name",
        width: 200
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "当前状态",
        prop: "enableStatusName",
        width: 100
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }, {
        label: "数量",
        prop: "num",
        // type: COLUMN_TYPE.input,
        // operationsKey: OPERATIONS.input,
        width: 100
      }]
    });

    function getGiveCouponOperations() {
      return [OPERATIONS.del];
    }

    function getCouponDataOperations() {
      return [OPERATIONS.select];
    }

    couponDataHandler.install(OP_KEY.select, data => {
      data.num = 1;
      giveCouponData.value.some(e => e.couponCode == data.couponCode) || giveCouponData.value.push(data);
    });
    const giveCouponDataHandler = operationsHander();
    giveCouponDataHandler.install(OP_KEY.delete, data => {
      giveCouponData.value = giveCouponData.value.filter(e => e.couponCode != data.couponCode);
    });
    opHander.install(OP_KEY.giveCoupon, data => {
      selectOpData = data;
      getCouponData();
      giveCouponData.value = [];
      giveCouponDrawer.value = true;
    });

    function getCouponData() {
      couponApi.list({
        name: couponName.value,
        page: couponDataPage.value,
        size: couponDataSize.value
      }, val => {
        couponData.value = val.list;
        couponDataTotal.value = val.total;
      });
    }

    function couponDataPageChange(type, val) {
      if (type == 'page') {
        couponDataPage.value = val;
      } else if (type == 'size') {
        couponDataSize.value = val;
      }

      getCouponData();
    }

    function giveCouponSubmit() {
      if (giveCouponData.value.length === 0) {
        $msg.error("请选择优惠券");
        return;
      } else {
        let couponCodes = giveCouponData.value.map(e => e.couponCode);
        const params = {
          afterSaleCode: selectOpData.afterSaleCode,
          couponList: couponCodes
        };
        api.giveCoupon(params, () => {
          $msg.succ("赠送成功");
          giveCouponDrawer.value = false;
          getData();
        });
      }
    }

    function searchBase(val) {
      route.replaceQuery("base", val);
    }

    function searchOrderCode(val) {
      route.replaceQuery("orderCode", val);
    }

    function searchAfterSale(val) {
      route.replaceQuery("afterSaleCode", val);
    }

    getData();

    function getData() {
      getNum();
      getList();
    }

    function getNum() {
      api.num(val => {
        statusData(val);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function getList() {
      let routeQuery = route.query();
      let params = {
        shopCode: routeQuery.base,
        orderCode: routeQuery.orderCode,
        afterSaleCode: routeQuery.afterSaleCode,
        status: routeQuery.status,
        page: routeQuery.p,
        size: routeQuery.s
      };
      api.list(params, val => {
        total.value = val.total;
        data.value = val.list;
      });
    }

    function getExport() {
      let routeQuery = route.query();
      let params = {
        shopCode: routeQuery.base,
        orderCode: routeQuery.orderCode,
        afterSaleCode: routeQuery.afterSaleCode,
        status: routeQuery.status
      };
      api.export(params, val => {
        $.download(val.url, "售后订单导出");
      });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_drawer = _resolveComponent("el-drawer");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        inline: true,
        class: "base_search_form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: base.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => base.value = $event),
            onChange: searchBase,
            placeholder: "请选择基地",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: orderCode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderCode.value = $event),
            "onKeyup[native]": searchOrderCode,
            onChange: searchOrderCode,
            placeholder: "订单编号",
            "suffix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: afterSaleCode.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => afterSaleCode.value = $event),
            "onKeyup[native]": searchAfterSale,
            onChange: searchAfterSale,
            placeholder: "售后单号",
            "suffix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(StatusBar, {
        data: statusList,
        default: "all"
      }, null, 8, ["data"]), props.type == 'order' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        text: "",
        onClick: getExport
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      })), [[_directive_auth, _ctx.getCurCode('EXPORT')]])])) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createVNode(DataCollectTable, {
        data: data.value,
        total: total.value,
        config: config,
        onOperationsHander: _unref(opHander).receive
      }, null, 8, ["data", "total", "onOperationsHander"]), _createVNode(CancelAfterSale, {
        ref_key: "cancelAfterSaleRef",
        ref: cancelAfterSaleRef,
        onCancelAfterSale: cancelAfterSale
      }, null, 512), _createVNode(ConfirmAfterSale, {
        ref_key: "confirmAfterSaleRef",
        ref: confirmAfterSaleRef,
        desc: expenseAftersale.value,
        money: refundMoney.value,
        deposit: depositMoney.value,
        onSubmit: confirmAfterSale
      }, null, 8, ["desc", "money", "deposit"]), _createVNode(_component_el_drawer, {
        "custom-class": "base_drawer",
        modelValue: giveCouponDrawer.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => giveCouponDrawer.value = $event),
        "close-on-click-modal": false,
        title: "赠送优惠券",
        "with-header": true,
        size: "80%"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => giveCouponDrawer.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: giveCouponSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("赠送")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: couponName.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => couponName.value = $event),
              "onKeyup[native]": getCouponData,
              onChange: getCouponData,
              placeholder: "优惠券名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(DataCollectTable, {
          ref_key: "couponTableRef",
          ref: couponTableRef,
          data: couponData.value,
          config: couponDataConfig.value,
          isRoute: false,
          onOperationsHander: _unref(couponDataHandler).receive,
          total: couponDataTotal.value,
          onPageChange: couponDataPageChange
        }, null, 8, ["data", "config", "onOperationsHander", "total"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(DataCollectTable, {
          ref: "giveCouponDataTableRef",
          data: giveCouponData.value,
          config: giveCouponDataConfig.value,
          isRoute: false,
          onOperationsHander: _unref(giveCouponDataHandler).receive,
          isPage: false
        }, null, 8, ["data", "config", "onOperationsHander"])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};